import { useTranslation } from "react-i18next";
import type { IButton } from "libs/design-system/src/types/Button/button";
import type { IEditModalProps } from "@app/dashboard/types/innerLayout/iframes/edit-iframe"; 
import type { IModalSharedProps } from "libs/design-system/src/types/modal";
import { Modal, StatusIndicator } from "@unified-checkout/design-system";
import { Check, Xmark } from "libs/design-system/src/assets/Icons";
import { IframeModal } from "..";


export const EditModal = ({
  open,
  isLoading,
  isError,
  isSuccess,
  iframeForm,
  onClose,
  onConfirm,
  onFormChange,
}: IEditModalProps) => {
  const isProcessDone = isError || isSuccess;

  const { t } = useTranslation();

  const title = isProcessDone ?
    ""
    :
    t("innerLayout.iFramesPage.editModal.title")

  const btns = isProcessDone ?
    []
    :
    [
      {
        size: "md",
        color: "primary",
        variant: "contained",
        text: t(`innerLayout.iFramesPage.addModal.submitForm`),
        onClickHandler: onConfirm,
        loading: isLoading,
        disabled: isLoading,
      } as IButton,
      {
        size: "md",
        color: "secondary",
        variant: "outlined",
        text: t("innerLayout.iFramesPage.deleteModal.cancelButton"),
        onClickHandler: onClose,
      } as IButton,
    ]
  const hintText = isError ?
    t("innerLayout.errors.smthWentWrong")
    :
    t("innerLayout.iFramesPage.editModal.successMessage")

  const modalProps: IModalSharedProps = {
    state: "default",
    open,
    onCloseHandler: onClose,
    hasCloseIcon: true,
    title,
    position: "center",
    btnsProps: btns
  }

  const status = isProcessDone ?
    (
      <StatusIndicator
        status={isError ? "error" : "success"}
        icon={isError ? Xmark : Check}
        hintText={hintText}
      />
    )
    :
    <IframeModal form={iframeForm} setForm={onFormChange} />;

  return (
    <Modal {...modalProps} >
      {status}
    </Modal>
  );
};
